<section class="container" aria-labelledby="contact-title">
	<h2 lvrPadding [padHorizontal]="32" [padVertical]="0" id="contact-title">
		{{ 'contact.contact_view.title' | transloco }} {{ client().name
		}}{{ client().firstName ? ', ' + client().firstName : '' }}
		@if (client().dateOfBirth) {
			*{{ client().dateOfBirth | date: dateDisplayFormat }}
		}
	</h2>

	<lvr-action-menu
		style="padding-bottom: 32px"
		[items]="menuItems()"
		[buttonAriaLabel]="'base.button.add_assignment' | transloco"
	/>

	@if (
		!isClientChanging() &&
		activeAssignment() &&
		activeAssignmentContactsCount() === 0 &&
		!activeAssignment()?.isRestricted
	) {
		<lvr-simple-panel>
			<div title>
				<span style="padding-right: 1rem">
					{{ 'contact.assignment_accordion.new_contact' | transloco }}
				</span>

				@if (canCreateContacts()) {
					<lvr-button
						variant="primary"
						[label]="'contact.assignment_accordion.contact' | transloco"
						[ariaLabel]="'contact.assignment_accordion.contact_hint' | transloco"
						type="button"
						(clicked)="openCreate()"
						icon="add"
					/>
				}
			</div>

			<p content>
				{{ 'contact.assignment_accordion.add_new_contact_hint' | transloco }}
			</p>
		</lvr-simple-panel>
	}
	<lvr-assignment-accordion
		[createLinkForAssignment]="createContactLink"
		[assignments]="assignmentsWithoutP0andContacts()"
		[loadingAssignments]="isClientChanging()"
		[contactLoadingByAssignmentId]="assignmentContactsLoading()"
		[contactErrorByAssignmentId]="assignmentContactsError()"
		[currentUserId]="user().id"
		[currentUser]="user()"
		[toggleOnIconOnly]="true"
		(move)="openPhaseSwitchDialog($event)"
		(moveToCancel)="moveToCancelAssignment($event)"
		(deleteDraftRequest)="onDeleteDraft($event)"
		(additionalDeleted)="onAdditionalDeleted($event)"
	></lvr-assignment-accordion>
</section>
